import React, { Fragment } from 'react'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { UpdateClientStatus } from 'api/Clients/Types/UpdateClientStatus'

import { AggregateDataTable } from '../../../../Transactions/Details/AggregateDataTable'
import { ClientNavigation, ClientTab } from '../../Navigation/ClientNavigation'

interface Props {
  data: ClientDetailedDto

  forceRefresh(): void
  updateClientStatus(values: UpdateClientStatus): void
}
const ClientDetailsFundingSummaryPage: React.FC<Props> = ({ data, updateClientStatus }) => {
  if (!data) {
    return null
  }

  return (
    <Fragment>
      <ClientNavigation
        isEdit={false}
        data={data}
        tab={ClientTab.FUNDING_SUMMARY}
        updateClientStatus={updateClientStatus}
      />
      <AggregateDataTable clientId={data.id} />
    </Fragment>
  )
}

export default ClientDetailsFundingSummaryPage
